import { render, staticRenderFns } from "./SettingsCategories.vue?vue&type=template&id=180abf10&scoped=true"
import script from "./SettingsCategories.vue?vue&type=script&lang=js"
export * from "./SettingsCategories.vue?vue&type=script&lang=js"
import style0 from "./SettingsCategories.vue?vue&type=style&index=0&id=180abf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180abf10",
  null
  
)

export default component.exports